import { isAxiosError } from 'axios';

// ─── List / search recommended forms ────────────────────────────────────────

export type Cn02RecommendedListItem = {
  cn02Id: string;
  refId: string;
  planterName: string;
  permitNo: string | null;
  teaNurseryName: string;
  isNewPermit: boolean;
  createdAt: string;
  expiredAt: string;
};

export type Cn02RecommendedFilters = {
  planterId?: string;
  createdDate?: string;
  permitNo?: string;
  expiredYear?: number;
  expiredMonth?: number;
  isNewPermit?: boolean;
};

export type Cn02RecommendedParams = Cn02RecommendedFilters & {
  page: number;
  pageSize: number;
};

export function buildCn02RecommendedParams(
  filters: Cn02RecommendedFilters,
  page: number,
  pageSize: number
): Cn02RecommendedParams {
  const params: Cn02RecommendedParams = { page, pageSize };
  const planterId = filters.planterId?.trim();
  if (planterId) params.planterId = planterId;
  const createdDate = filters.createdDate?.trim();
  if (createdDate) params.createdDate = createdDate;
  const permitNo = filters.permitNo?.trim();
  if (permitNo) params.permitNo = permitNo;
  if (filters.expiredYear != null && filters.expiredMonth != null) {
    params.expiredYear = filters.expiredYear;
    params.expiredMonth = filters.expiredMonth;
  }
  if (filters.isNewPermit != null) params.isNewPermit = filters.isNewPermit;
  return params;
}

// ─── Planters dropdown ───────────────────────────────────────────────────────

export type Cn02PlanterOption = {
  planterId: string;
  planterName: string;
};

// ─── Detail by ID ────────────────────────────────────────────────────────────

export type Cn02ByIdDetail = {
  cn02Id: string;
  refId: string;
  permitNo: string;
  planterFullName: string;
  planterFullAddress: string;
  district: string;
  village: string | null;
  landHeck: number | null;
  landAk: number | null;
  landRudi: number | null;
  landP: number | null;
  noOfPlants: number | null;
  noPlantsWord: string | null;
  officerName: string | null;
  expiredAt: string;
  createdAt: string;
};

// ─── Error helper (shared across CN pages) ───────────────────────────────────

export function getApiErrorMessage(error: unknown, fallback = 'Request failed'): string {
  if (!isAxiosError(error)) {
    return error instanceof Error ? error.message : fallback;
  }
  const data = error.response?.data as Record<string, unknown> | string | undefined;
  if (typeof data === 'string' && data.trim()) return data;
  if (data && typeof data === 'object') {
    const msg = data.message;
    if (typeof msg === 'string' && msg.trim()) return msg;
    if (Array.isArray(msg) && msg.length && typeof msg[0] === 'string') return msg.join(' ');
    if (typeof msg === 'object' && msg !== null && 'message' in msg) {
      const inner = (msg as { message?: string }).message;
      if (typeof inner === 'string' && inner.trim()) return inner;
    }
    if (typeof data.error === 'string' && data.error.trim()) return data.error;
  }
  if (error.message?.trim()) return error.message;
  return fallback;
}

